import axios from 'axios';

const apiEndpoint = process.env.VUE_APP_API_BASEURL;

export default {
  getCompanies() {
    return axios.get(`${apiEndpoint}/dashboard/manual-jobs/companies`);
  },
  getClassifications() {
    return axios.get(`${apiEndpoint}/dashboard/manual-jobs/classifications`);
  },
  getJobs(companyId) {
    return axios.get(`${apiEndpoint}/dashboard/manual-jobs/${companyId}`);
  },
  createJob(companyId, payload) {
    return axios.post(`${apiEndpoint}/dashboard/manual-jobs/${companyId}`, payload, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  },
  updateJob(companyId, jobId, payload) {
    return axios.patch(`${apiEndpoint}/dashboard/manual-jobs/${companyId}/${jobId}`, payload, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  },
  deleteJob(companyId, jobId) {
    return axios.delete(`${apiEndpoint}/dashboard/manual-jobs/${companyId}/${jobId}`);
  },
  reorderJobs(companyId, jobIds) {
    return axios.post(`${apiEndpoint}/dashboard/manual-jobs/${companyId}/reorder`, {
      job_ids: jobIds,
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }
}
